import { render, staticRenderFns } from "./mobilePageHeaderBack.vue?vue&type=template&id=45aacc85&scoped=true"
import script from "./mobilePageHeaderBack.vue?vue&type=script&lang=js"
export * from "./mobilePageHeaderBack.vue?vue&type=script&lang=js"
import style0 from "./mobilePageHeaderBack.vue?vue&type=style&index=0&id=45aacc85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45aacc85",
  null
  
)

export default component.exports